import React from "react";

export class CourseRating extends React.Component {
    render() {
        const lvl = parseInt(this.props.rating);
        const cls1 = lvl >= 1 ? 'filled' : '';
        const cls2 = lvl >= 2 ? 'filled' : '';
        const cls3 = lvl >= 3 ? 'filled' : '';
        const cls4 = lvl >= 4 ? 'filled' : '';
        const cls5 = lvl === 5 ? 'filled' : '';

        return (
            <svg className="icon_course_rating" width="96" height="24" viewBox="0 0 96 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 4L9.79611 9.52786H15.6085L10.9062 12.9443L12.7023 18.4721L8 15.0557L3.29772 18.4721L5.09383 12.9443L0.391548 9.52786H6.20389L8 4Z" className={cls1}/>
                <path d="M28 4L29.7961 9.52786H35.6085L30.9062 12.9443L32.7023 18.4721L28 15.0557L23.2977 18.4721L25.0938 12.9443L20.3915 9.52786H26.2039L28 4Z" className={cls2}/>
                <path d="M48 4L49.7961 9.52786H55.6085L50.9062 12.9443L52.7023 18.4721L48 15.0557L43.2977 18.4721L45.0938 12.9443L40.3915 9.52786H46.2039L48 4Z" className={cls3}/>
                <path d="M68 4L69.7961 9.52786H75.6085L70.9062 12.9443L72.7023 18.4721L68 15.0557L63.2977 18.4721L65.0938 12.9443L60.3915 9.52786H66.2039L68 4Z" className={cls4}/>
                <path d="M88 4L89.7961 9.52786H95.6085L90.9062 12.9443L92.7023 18.4721L88 15.0557L83.2977 18.4721L85.0938 12.9443L80.3915 9.52786H86.2039L88 4Z" className={cls5}/>
            </svg>
        );
    }
}

export class VideoCourse extends React.Component {
    render() {
        return (
            <svg className="cl_icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <g transform="translate(-321 -1765)">
                    <rect className="a" fill="#2450ff" width="20" height="20" rx="10" transform="translate(321 1765)"/>
                    <path className="b" fill="#fff"
                          d="M3.584.624a.5.5,0,0,1,.832,0l3.066,4.6A.5.5,0,0,1,7.066,6H.934a.5.5,0,0,1-.416-.777Z"
                          transform="translate(335 1771) rotate(90)"/>
                </g>
            </svg>
        );
    }
}

export class Views extends React.Component {
    render() {
        return (
            <svg className="cl_icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <g transform="translate(-425 -550)">
                    <rect className="a" fill="none" width="20" height="20" transform="translate(425 550)"/>
                    <g className="b" fill="none" transform="translate(425 545)">
                        <path className="d" stroke="none" d="M.458,15a10,10,0,0,1,19.084,0A10,10,0,0,1,.458,15Z"/>
                        <path className="e" fill="#fff" stroke="none"
                              d="M 9.999904632568359 20.99960136413574 C 11.95443439483643 20.99960136413574 13.81293392181396 20.38408088684082 15.3744945526123 19.21957206726074 C 16.80030059814453 18.15629196166992 17.89697265625 16.66691398620605 18.48775863647461 15.00002861022949 C 17.8969554901123 13.33317375183105 16.80027008056641 11.8437442779541 15.37445449829102 10.78036117553711 C 13.81284427642822 9.615711212158203 11.95435428619385 9.000101089477539 9.999904632568359 9.000101089477539 C 8.045754432678223 9.000101089477539 6.187384128570557 9.615711212158203 4.625714302062988 10.78037166595459 C 3.199775218963623 11.84381103515625 2.103009939193726 13.33318519592285 1.512126445770264 15.00001621246338 C 2.102983713150024 16.66686820983887 3.199745416641235 18.15622520446777 4.625684261322021 19.21956062316895 C 6.187294006347656 20.38407135009766 8.045663833618164 20.99960136413574 9.999904632568359 20.99960136413574 M 9.999904632568359 21.99960136413574 C 5.522724151611328 21.99960136413574 1.732354164123535 19.05708122253418 0.4579241871833801 15.0000114440918 C 1.732354164123535 10.94320106506348 5.522724151611328 8.000101089477539 9.999904632568359 8.000101089477539 C 14.47780418395996 8.000101089477539 18.26771354675293 10.94320106506348 19.54194450378418 15.0000114440918 C 18.26771354675293 19.05708122253418 14.47780418395996 21.99960136413574 9.999904632568359 21.99960136413574 Z"/>
                    </g>
                    <circle className="c" fill="#fff" cx="3" cy="3" r="3" transform="translate(432 557)"/>
                </g>
            </svg>
        );
    }
}

export class Certificate extends React.Component {
    render() {
        return (
            <svg className="cl_icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                <g transform="translate(-673 -609)">
                    <path className="a" fill="#c89e59"
                          d="M12.742,0l.977,2.631,2.337-1.554.116,2.8,2.7-.756-.756,2.7,2.8.116L19.369,8.281,22,9.258,19.8,11,22,12.742l-2.631.977,1.554,2.337-2.8.116.756,2.7-2.7-.756-.116,2.8-2.337-1.554L12.742,22,11,19.8,9.258,22l-.977-2.631L5.944,20.923l-.116-2.8-2.7.756.756-2.7-2.8-.116,1.554-2.337L0,12.742,2.2,11,0,9.258l2.631-.977L1.077,5.944l2.8-.116-.756-2.7,2.7.756.116-2.8L8.281,2.631,9.258,0,11,2.2Z"
                          transform="translate(673 609)"/>
                    <path className="b" fill="#040e26"
                          d="M10.325-8.613,7.645-1.74H7.2L5.33-5.974,3.452-1.74H3.005L.325-8.613H1.848L3.34-4.624,5.1-8.736h.457L7.31-4.645,8.8-8.613Z"
                          transform="translate(678.675 625.736)"/>
                </g>
            </svg>
        );
    }
}

export class Difficulty extends React.Component {
    render() {
        const lvl = this.props.lvl;
        const cls1 = lvl > 0 ? 'filled' : '';
        const cls2 = lvl > 1 ? 'filled' : '';
        const cls3 = lvl > 2 ? 'filled' : '';

        return (
            <svg className="cl_icon difficulty_icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle className={cls1} cx="8.5" cy="15.5" r="2"/>
                <circle className={cls2} cx="16.5" cy="15.5" r="2"/>
                <circle className={cls3} cx="12.5" cy="8.5" r="2"/>
            </svg>
        );
    }
}

export class SkillsListTick extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <circle fill="#040e26" className="a" cx="15" cy="15" r="15"/>
                <path fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2" className="b"
                      d="M78,1568l4,4,8-9" transform="translate(-68.5 -1552.5)"/>
            </svg>
        );
    }
}

export class TypeVideo extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <rect fill="#2450ff" className="a" width="30" height="30" rx="15"/>
                <path fill="#fff" className="b"
                      d="M4.726.334a.75.75,0,0,1,1.248,0l4.6,6.9A.75.75,0,0,1,9.948,8.4H.751A.75.75,0,0,1,.127,7.232Z"
                      transform="translate(20.398 9.65) rotate(90)"/>
            </svg>
        );
    }
}

export class TypeText extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <g transform="translate(-285 -3315)">
                    <circle className="a" fill="#6ab261" cx="15" cy="15" r="15" transform="translate(285 3315)"/>
                    <path className="b" fill="#fff"
                          d="M8.749,10a.75.75,0,0,1,0-1.5h7.5a.75.75,0,1,1,0,1.5Zm0-5.25a.75.75,0,0,1,0-1.5h13.5a.75.75,0,1,1,0,1.5Zm0-5.25A.75.75,0,0,1,8-1.251.75.75,0,0,1,8.749-2h13.5A.75.75,0,0,1,23-1.251a.751.751,0,0,1-.751.751Z"
                          transform="translate(284.5 3326)"/>
                </g>
            </svg>
        );
    }
}

export class TypePdf extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <g transform="translate(110 -4516)">
                    <rect className="a" fill="#b30b00" width="30" height="30" rx="15" transform="translate(-110 4516)"/>
                    <path className="b" fill="#fff"
                          d="M29.91,22.563c-.6-.648-1.744-.947-3.389-.947a16.986,16.986,0,0,0-2.741.249,14.117,14.117,0,0,1-1.595-1.844,16.366,16.366,0,0,1-1-1.545,16.345,16.345,0,0,0,.9-4.385c0-1.346-.548-2.791-2.043-2.791a1.468,1.468,0,0,0-1.246.748c-.648,1.1-.4,3.339.648,5.681-.349,1.047-.748,2.093-1.2,3.239a18.775,18.775,0,0,1-1.4,2.841c-1.545.6-4.784,2.093-5.083,3.738a1.269,1.269,0,0,0,.449,1.3,1.843,1.843,0,0,0,1.346.449c1.944,0,3.887-2.691,5.233-5.033.748-.249,1.5-.5,2.292-.7.847-.2,1.645-.4,2.392-.548A7.623,7.623,0,0,0,28.315,25.1c1.246,0,1.744-.548,1.894-1A1.456,1.456,0,0,0,29.91,22.563Zm-1.346.947c-.05.349-.449.6-.947.6a1.38,1.38,0,0,1-.449-.05,7.158,7.158,0,0,1-2.741-1.4,13.42,13.42,0,0,1,1.993-.15,12.219,12.219,0,0,1,1.346.1C28.215,22.712,28.714,22.911,28.564,23.509ZM19.644,12.5a.726.726,0,0,1,.449-.3c.5,0,.6.548.6,1.047a12.71,12.71,0,0,1-.6,3.339C19.245,14.44,19.345,12.994,19.644,12.5Zm2.791,9.568c-.548.1-1.1.249-1.645.4-.4.1-.8.249-1.246.349.2-.449.4-.9.6-1.3.249-.548.449-1.1.648-1.645.2.3.349.548.548.8.349.5.748.947,1.1,1.4Zm-6.03,2.89c-1.246,1.993-2.492,3.289-3.189,3.289a.534.534,0,0,1-.3-.1.4.4,0,0,1-.15-.449c.1-.748,1.545-1.794,3.638-2.741Z"
                          transform="translate(-115.31 4509.7)"/>
                </g>
            </svg>
        );
    }
}

export class TypeWebinar extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <g transform="translate(-670 -566)">
                    <rect className="a" fill="#be0b0b" width="30" height="30" rx="15" transform="translate(670 566)"/>
                    <path className="b" fill="#fff"
                          d="M393-2694.593a10.5,10.5,0,0,1,9.442-5.9,10.5,10.5,0,0,1,9.443,5.9,11.977,11.977,0,0,1-9.443,4.6A11.973,11.973,0,0,1,393-2694.593Zm4.942-11.907a4.5,4.5,0,0,1,4.5-4.5,4.5,4.5,0,0,1,4.5,4.5,4.5,4.5,0,0,1-4.5,4.5A4.5,4.5,0,0,1,397.943-2706.5Z"
                          transform="translate(282.558 3283)"/>
                </g>
            </svg>
        );
    }
}

export class LessonUnfold extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path fill="#040e26" opacity=".5" className="a" d="M9,20V11H0V9H9V0h2V9h9v2H11v9Z"/>
            </svg>
        );
    }
}

export class LessonFold extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="2" viewBox="0 0 20 2">
                <path fill="#040e26" opacity=".5" className="a" d="M0,2V0H20V2Z"/>
            </svg>
        );
    }
}

export class SchoolLike extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40">
                <path fill="#2450ff" className="a" d="M0,0H30V40L15,30,0,40Z"/>
                <path fill="#fff" className="b"
                      d="M14.714,11.428h.429a.857.857,0,0,0,0-1.714H10.428a17.357,17.357,0,0,0,.429-3.857.857.857,0,1,0-1.714,0s-.857,4.714-3.857,4.714H4v5.143H6.143c.857,0,2.571.857,3.428.857h4.286a.857.857,0,0,0,0-1.714h.429a.857.857,0,1,0,0-1.714h.429a.857.857,0,1,0,0-1.714"
                      transform="translate(5 4)"/>
            </svg>
        );
    }
}

export class RatingStar extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30">
                <path fill="#e4e4e4" className="a"
                      d="M16,0l4.8,10.071L32,11.459l-8.233,7.612L25.889,30,16,24.633,6.111,30,8.233,19.071,0,11.459l11.2-1.388Z"/>
            </svg>
        );
    }
}

export class FoldSwitcherDots extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="4" viewBox="0 0 22 4">
                <g transform="translate(-229 -2414)">
                    <circle className="a" fill="#2450ff" cx="2" cy="2" r="2" transform="translate(229 2414)"/>
                    <circle className="a" fill="#2450ff" cx="2" cy="2" r="2" transform="translate(238 2414)"/>
                    <circle className="a" fill="#2450ff" cx="2" cy="2" r="2" transform="translate(247 2414)"/>
                </g>
            </svg>
        );
    }
}

export class ShareArrow extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                <circle className="a" fill="none" cx="15" cy="15" r="15"/>
                <path className="b" fill="#fff" opacity="0.7"
                      d="M0,12.782a9.964,9.964,0,0,0,.3,2.45c.1.45.35.45.5,0,1.05-2.65,2.75-5.15,5.55-5.65H8v2.2c0,1,.6,1.3,1.3.7l6.4-5.5a.761.761,0,0,0,0-1.15L9.3.332c-.7-.65-1.3-.3-1.3.65v2.35A9.387,9.387,0,0,0,0,12.782Z"
                      transform="translate(7 7)"/>
            </svg>
        );
    }
}

export class Bin extends React.Component {
    render() {
        return (
            <svg height="512pt" viewBox="-64 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg">
                <path d="m256 80h-32v-48h-64v48h-32v-80h128zm0 0" fill="#434A5C"/>
                <path d="m304 512h-224c-26.507812 0-48-21.492188-48-48v-336h320v336c0 26.507812-21.492188 48-48 48zm0 0"
                      fill="#C33333"/>
                <path d="m384 160h-384v-64c0-17.671875 14.328125-32 32-32h320c17.671875 0 32 14.328125 32 32zm0 0" fill="#434A5C"/>
                <path d="m260 260c-6.246094-6.246094-16.375-6.246094-22.625 0l-41.375 41.375-41.375-41.375c-6.25-6.246094-16.378906-6.246094-22.625 0s-6.246094 16.375 0 22.625l41.375 41.375-41.375 41.375c-6.246094 6.25-6.246094 16.378906 0 22.625s16.375 6.246094 22.625 0l41.375-41.375 41.375 41.375c6.25 6.246094 16.378906 6.246094 22.625 0s6.246094-16.375 0-22.625l-41.375-41.375 41.375-41.375c6.246094-6.25 6.246094-16.378906 0-22.625zm0 0"
                      fill="#fff"/>
            </svg>
        );
    }
}

export class BtnPlay extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                <g transform="translate(-321 -1764.77)">
                    <rect className="a" opacity="0.5" width="60" height="60" rx="30" transform="translate(321 1764.77)"/>
                    <path className="b" fill="#fff"
                          d="M11.584.624a.5.5,0,0,1,.832,0l11.066,16.6a.5.5,0,0,1-.416.777H.934a.5.5,0,0,1-.416-.777Z"
                          transform="translate(363 1782.77) rotate(90)"/>
                </g>
            </svg>
        );
    }
}

export class WHub extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="56.5" height="40" viewBox="0 0 56.5 40">
                <g transform="translate(-649 -19.5)">
                    <path className="a" fill="#1cfe00"
                          d="M426.958,336.978V351.5H415.925V336.978h-10.67v39h10.67V360.5h11.032v15.481h10.669v-39Z"
                          transform="translate(267.873 -316.977)"/>
                    <g transform="translate(649 20)">
                        <path className="b" fill="#fe13c9"
                              d="M407.269,375.978l-6.837-39H410.99l2.165,17.04q.3,3.06.655,6.12c.245,2.04.46,4.08.665,6.12h.24c.355-2.04.72-4.08,1.075-6.12s.72-4.08,1.085-6.12l3.716-17.04h8.642l3.726,17.04c.355,1.96.72,3.97,1.075,6.03s.72,4.13,1.085,6.21h.24q.3-3.12.655-6.18c.245-2.04.46-4.06.665-6.06l2.155-17.04h9.847l-6.482,39H429.113l-3-15.48q-.48-2.28-.8-4.62t-.635-4.5h-.24q-.3,2.16-.63,4.5c-.215,1.56-.49,3.1-.81,4.62l-2.876,15.48Z"
                              transform="translate(-400.432 -336.978)"/>
                    </g>
                    <path className="c" stroke="rgba(0,0,0,0)" strokeMiterlimit="10"
                          d="M4.558,39l-3-15.479q-.479-2.28-.8-4.62T.119,14.4H0V0H4.678L8.4,17.04c.355,1.96.719,3.97,1.075,6.03s.72,4.13,1.084,6.21h.108V39ZM16.4,23.518H11.41l.048-.418c.244-2.041.46-4.061.664-6.06l.319-2.521H21.7V0h2.419L20.215,23.518Z"
                          transform="translate(673.129 20)"/>
                </g>
            </svg>
        );
    }
}

export class TimeWatchIcon extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <g transform="translate(-2.25 -2.25)">
                    <g transform="translate(2.75 2.75)">
                        <path className="a" fill="none" stroke="#040e26" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10"
                              d="M15,7.5A7.5,7.5,0,1,1,7.5,0,7.5,7.5,0,0,1,15,7.5Z" transform="translate(0 0)"/>
                        <path className="a" fill="none" stroke="#040e26" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M3.057,5.754,0,3.93V0" transform="translate(7.226 4.132)"/>
                    </g>
                </g>
            </svg>
        );
    }
}

export class BroadcastIcon extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="30.001" viewBox="0 0 45 30.001">
                <g className="a" fill="none" transform="translate(10950 2.001)">
                    <path className="b" stroke="none"
                          d="M-10946,28a4,4,0,0,1-4-4V2a4,4,0,0,1,4-4h26a4,4,0,0,1,4,4V7.237l7.9-5.2a2,2,0,0,1,3.1,1.671v17.58a2,2,0,0,1-3.1,1.671l-7.9-5.2V24a4,4,0,0,1-4,4Z"/>
                    <path className="c" stroke="none" fill="#040e26"
                          d="M -10919.9990234375 26.00026893615723 C -10918.8974609375 26.00026893615723 -10918.0009765625 25.1025276184082 -10918.0009765625 23.99904823303223 L -10918.0009765625 17.76351928710938 L -10918.0009765625 14.05430793762207 L -10914.90234375 16.09253883361816 L -10907 21.28968620300293 C -10907 21.28960418701172 -10907 21.28952217102051 -10907 21.28943824768066 L -10907 3.710413217544556 C -10907 3.710293292999268 -10907 3.710175275802612 -10907.0009765625 3.710059404373169 L -10914.9013671875 8.908278465270996 L -10918.0009765625 10.94730854034424 L -10918.0009765625 7.237458229064941 L -10918.0009765625 2.000608444213867 C -10918.0009765625 0.8971283435821533 -10918.8974609375 -0.0006116613512858748 -10919.9990234375 -0.0006116613512858748 L -10945.9990234375 -0.0006116613512858748 C -10947.1025390625 -0.0006116613512858748 -10948 0.8971283435821533 -10948 2.000608444213867 L -10948 23.99904823303223 C -10948 25.1025276184082 -10947.1025390625 26.00026893615723 -10945.9990234375 26.00026893615723 L -10919.9990234375 26.00026893615723 M -10919.9990234375 28.00026893615723 L -10945.9990234375 28.00026893615723 C -10948.2080078125 28.00026893615723 -10950 26.20851898193359 -10950 23.99904823303223 L -10950 2.000608444213867 C -10950 -0.2088516652584076 -10948.2080078125 -2.000611543655396 -10945.9990234375 -2.000611543655396 L -10919.9990234375 -2.000611543655396 C -10917.7900390625 -2.000611543655396 -10916.0009765625 -0.2088516652584076 -10916.0009765625 2.000608444213867 L -10916.0009765625 7.237458229064941 L -10908.099609375 2.039078235626221 C -10907.751953125 1.810738325119019 -10907.3740234375 1.70713484287262 -10907.005859375 1.70713484287262 C -10905.9658203125 1.70713484287262 -10905 2.534529685974121 -10905 3.709918260574341 L -10905 21.28943824768066 C -10905 22.46607971191406 -10905.96484375 23.29377365112305 -10907.0048828125 23.2938117980957 C -10907.373046875 23.29382514953613 -10907.7509765625 23.18976211547852 -10908.099609375 22.96027755737305 L -10916.0009765625 17.76351928710938 L -10916.0009765625 23.99904823303223 C -10916.0009765625 26.20851898193359 -10917.7900390625 28.00026893615723 -10919.9990234375 28.00026893615723 Z"/>
                </g>
            </svg>
        );
    }
}

export class ArrowBack extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="6.061" height="10.707" viewBox="0 0 6.061 10.707">
                <path className="a" fill="none" stroke="#040e26" opacity="0.7" d="M1662.6,3821.912l-5,5,5,5"
                      transform="translate(-1656.893 -3821.558)"/>
            </svg>
        );
    }
}

export class CloseCross extends React.Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <g transform="translate(-315 -95)">
                    <rect className="a" fill="none" width="20" height="20" transform="translate(315 95)"/>
                    <path className="b" fill="#040e26"
                          d="M10,11.414,3.636,17.778,2.222,16.364,8.586,10,2.222,3.636,3.636,2.222,10,8.586l6.364-6.364,1.414,1.414L11.414,10l6.364,6.364-1.414,1.414Z"
                          transform="translate(315 95)"/>
                </g>
            </svg>
        );
    }
}



